import MenuItem from '@mui/material/MenuItem';
import { createLink } from '@tanstack/react-router';

import type { MenuItemProps } from '@mui/material/MenuItem';
import type { LinkComponent } from '@tanstack/react-router';

function MuiMenuItem(props: Omit<MenuItemProps<'a'>, 'href'>) {
	return <MenuItem component='a' {...props} />;
}

const WrappedMenuItem = createLink(MuiMenuItem);

// eslint-disable-next-line react/function-component-definition -- Need to declare the type of the component as a whole
export const MenuItemLink: LinkComponent<typeof MuiMenuItem> = function (props) {
	return <WrappedMenuItem {...props} />;
};
